import {defineMessages} from 'react-intl';

export default defineMessages({
	shippingAddressLabel: {
		id: 'orders.details.shippingAddressLabel',
		defaultMessage: 'Shipping Address'
	},
	billingAddressLabel: {
		id: 'orders.details.billingAddressLabel',
		defaultMessage: 'Billing Address'
	},
});
